import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';
import { AngularFireStorage } from '@angular/fire/storage'

@Injectable({
  providedIn: 'root'
})
export class PrivateSectorService {

  constructor(private db: AngularFireDatabase, private storage: AngularFireStorage) { }

  getSubCategories(){
    return this.db.list('/subcategory', ref => ref.orderByChild('id')).valueChanges();
  }

  getSubCategory(id){
    return this.db.list('/subcategory/' + id).valueChanges();
  }

  getItems(id){
    return this.db.list('/private_sector/' + id).snapshotChanges();
  }

  deleteItem(number: String){
    console.log("Eliminar " + number);
  }

  getItem(subcategoryId: String, number: string) {
    return this.db.object('/private_sector/' +subcategoryId + "/" + number).valueChanges();
  }

  updateItem(subcategoryId: String, number: string, item) {
    return this.db.object('/private_sector/' +subcategoryId + "/" + number).update(item);
  }

  uploadFile(file, subcategoryId: String, number: String) {
    console.log("Uploading " + file);
    number = "1"
    var fileRef = this.storage.ref("imagesv2/private_sector/"+ subcategoryId +"/" + number);
    fileRef.put(file).then(function(snapshot) {
      console.log('Uploaded a blob or file!');
    });
  }
}
